import { httpGet, httpPost } from './api/axios_api';
import Constants from '../constants/constants';
import actions from './result_actions';

export async function getProgressKeys() {
  const url = `${Constants.BACKEND_URL}/get-progress-keys`;

  return httpGet(url, {});
}

export async function getWorldCupResults() {
  const url = `${Constants.BACKEND_URL}/get-world-cup-leaderboard-stats`;

  return httpGet(url, {});
}

export async function getPlayerProgress(playerID, gameID, skillID, positionID, func_type, relevantKey) {
  const url = `${Constants.BACKEND_URL}/get-player-progress`;

  const params = {
    relevant_key: relevantKey,
    player_id: playerID,
    game_id: gameID,
    skill_id: skillID,
    position_id: positionID,
    func_type: func_type,
  };

  const config = {
    params: params,
  };

  return httpPost(url, config);
}

export async function getPlayerFavoriteGame(playerID) {
  const url = `${Constants.BACKEND_URL}/get-player-favorite-game/${playerID}`;
  return httpGet(url, {});
}

export async function getPlayerFavoritePosition(playerID) {
  const url = `${Constants.BACKEND_URL}/get-player-favorite-position/${playerID}`;
  return httpGet(url, {});
}

export async function getPlayerGameResultsForSummary(playerID) {
  const url = `${Constants.BACKEND_URL}/get-player-results-for-summary/${playerID}`;
  return httpGet(url, {});
}

export async function getPlayerGameSessionResultsAsync(playerGameSessionID) {
  const url = `${Constants.BACKEND_URL}/get-player-game-session-results/${playerGameSessionID}`;
  return httpGet(url, {});
}

export function getPlayerROMData(playerID) {
  return (dispatch) => {
    const url = `${Constants.BACKEND_URL}/player-rom-overview/${playerID}`;
    httpGet(url, {}).then((response) => {
      if (response.data.success) {
        dispatch({
          type: actions.updatePlayerROMData,
          rom_data: response.data.data,
        });
      } else {
        //TODO: handle results load error
      }
    });
  };
}

export function getPlayerAngleSectionData(playerID) {
  return (dispatch) => {
    const url = `${Constants.BACKEND_URL}/player-angle-overview/${playerID}`;
    httpGet(url, {}).then((response) => {
      if (response.data.success) {
        dispatch({
          type: actions.updateAngleData,
          angle_data: response.data.data,
        });
      } else {
        //TODO: handle results load error
      }
    });
  };
}

export function getPlayerMinutesPlayed(playerID) {
  return (dispatch) => {
    const url = `${Constants.BACKEND_URL}/player-minutes-played/${playerID}`;
    httpGet(url, {}).then((response) => {
      if (response.data.success) {
        dispatch({
          type: actions.updateMinutesPlayed,
          minutes_played: response.data.data,
        });
      } else {
        //TODO: handle results load error
      }
    });
  };
}
